// extracted by mini-css-extract-plugin
module.exports = {"trigger":"NotificationsMenu_trigger__3FjmV","bubble":"NotificationsMenu_bubble__2gaOQ"};